import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { useGetShiftTypesQuery } from "AppQuries/shift/type/shift-type";
import { useGetAllUserGroupQuery } from "AppQuries/user/user-group";
import { useFormattedCompanyListForClientOption } from "core/Operations/formattedOption/useFormattedMasterOptions";

const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const isStatusOption2 = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const UserMasterForm = () => {
  const {
    control,
    register,
    watch,
    setValue,
    trigger,
    getValues,
    formState: { errors },
  } = useFormContext();

  const [showPassword, setShowPassword] = useState(false);
  const { data: groups } = useGetAllUserGroupQuery(
    {
      companyCode: watch("companyCode"),
      //   isTrue: showActiveOnly,
    },
    {
      enabled: watch("companyCode"),
    },
  );

  const companyListForClientOptions = useFormattedCompanyListForClientOption(
    watch("companyCode"),
  );

  const userGroupOptions = Array.isArray(groups)
    ? groups.map((g) => ({
        label: g.userGroupName,
        value: g.userGroupCode,
      }))
    : [];

  return (
    <div className="form-row row">
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="userName"
          type="text"
          placeholder="User Name"
          className={`form-control ${errors.userName ? "is-invalid" : ""}`}
          label="User Name"
          labelClassName="form-label"
          required={true}
          requiredMessage="User Name is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="emailId"
          type="email"
          placeholder="Email Id"
          className={`form-control ${errors.emailId ? "is-invalid" : ""}`}
          label="Email Id"
          labelClassName="form-label"
          required={true}
          requiredMessage="Email Id is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        {/* <div className="form-login"> */}

        <div className="pass-group form-floating">
          <input
            type={showPassword ? "text" : "password"}
            {...register("password", {
              required: "Please enter password",
            })}
            placeholder="*****"
            className={`form-control ${errors.password ? "is-invalid" : ""}`}
            required={
              getValues("userID") === "0" || getValues("userID") === 0
                ? true
                : false
            }
          />
          <span
            onClick={() => setShowPassword((prev) => !prev)}
            className={`fas toggle-password ${
              showPassword ? "fa-eye" : "fa-eye-slash"
            }`}
          />
          <label>Password</label>
          <div className="invalid-feedback">{errors.password?.message}</div>
        </div>

        {/* </div> */}
        {/* <Input
          name="password"
          type="password"
          placeholder="Password"
          className={`form-control ${errors.password ? "is-invalid" : ""}`}
          label="Password"
          labelClassName="form-label"
          required={getValues("userID") === "0" || getValues("userID") === 0 ? true : false}
          requiredMessage="Password is required"
          defaultValue=""
        /> */}
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        {/* <div className="form-login"> */}

        <div className="pass-group form-floating">
          <input
            type={showPassword ? "text" : "password"}
            {...register("appPin", {
              required: "Please enter app pin",
              minLength: {
                value: 4,
                message: "PIN must be 4 digits",
              },
              maxLength: {
                value: 4,
                message: "PIN must be 4 digits",
              },
              pattern: {
                value: /^[0-9]{4}$/,
                message: "Only 4 digit PIN allowed",
              },
            })}
            placeholder="*****"
            className={`form-control ${errors?.appPin ? "is-invalid" : ""}`}
            inputMode="numeric"
            maxLength={4}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/\D/g, "").slice(0, 4);
            }}
          />
          <span
            onClick={() => setShowPassword((prev) => !prev)}
            className={`fas toggle-password ${
              showPassword ? "fa-eye" : "fa-eye-slash"
            }`}
          />
          <label>App PIN</label>
          <div className="invalid-feedback">{errors?.appPin?.message}</div>
        </div>
      </div>

      <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
        <Input
          name="userGroupCode"
          type="commonSelect"
          placeholder="Select User Group"
          className={`form-control ${
            errors.userGroupCode ? "form-control is-invalid" : ""
          }`}
          label="User Group"
          labelClassName="form-label"
          optionData={userGroupOptions}
          required={false}
          requiredMessage="User Group is required"
          onChange={(selectedOption) => {
            setValue("userGroupCode", selectedOption);
            trigger("userGroupCode");
          }}
          defaultValue={watch("userGroupCode")}
        />
      </div>

      <div className="col-md-4 col-lg-4 col-sm-6 mb-3">
        <Input
          name="accessCompanies"
          type="commonSelect"
          placeholder="Select User Group"
          className={`form-control ${
            errors.accessCompanies ? "form-control is-invalid" : ""
          }`}
          label="Allowed Companies"
          labelClassName="form-label"
          optionData={companyListForClientOptions}
          required={true}
          requiredMessage="User Group is required"
          // onChange={(selectedOption) => {
          //   setValue("accessCompanies", selectedOption);
          //   trigger("accessCompanies");
          // }}
          mode="multiple"
          onChange={(selectedOptions) => {
            console.log(selectedOptions);
            setValue(
              "accessCompanies",
              Array.isArray(selectedOptions)
                ? selectedOptions.map((option) => option)
                : [],
            );
          }}
          defaultValue={watch("accessCompanies")}
          allowClear
          showSearch
          style={{ width: "100%", height: "auto" }}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isLock"
          type="commonSelect"
          placeholder="Select Status"
          className={`form-control select ${errors.isLock ? "is-invalid" : ""}`}
          label="Is Locked ?"
          labelClassName="form-label"
          optionData={isStatusOption2}
          required={true}
          requiredMessage="Locked is required"
          onChange={(selectedOption) => {
            setValue("isLock", selectedOption ? selectedOption.value : null);
            trigger("isLock");
          }}
          defaultValue={watch("isLock")}
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder="Select Status"
          className={`form-control select ${
            errors.isActive ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption ? selectedOption.value : null);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>
    </div>
  );
};

export default UserMasterForm;
